import { PROFILE, scrollTo } from "../data/constants";
import resumePDF from "../assets/Nisarg_Patel.pdf";
import { IconPin, IconGlobe, IconMail, IconBriefcase, IconBranch, IconDownload } from "./icons";

export default function Sidebar() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 13 }}>
        <span className="avatar" aria-hidden="true">{PROFILE.initials}</span>
        <div style={{ minWidth: 0 }}>
          <p className="side-name">{PROFILE.name}</p>
          <p className="side-role">{PROFILE.role}</p>
        </div>
      </div>

      <p className="side-bio">{PROFILE.bio}</p>

      <div className="side-meta">
        <span className="side-meta-row">
          <span className="ico"><IconBriefcase /></span> {PROFILE.role} · Manulife
        </span>
        <span className="side-meta-row">
          <span className="ico"><IconPin /></span> {PROFILE.location}
        </span>
        <span className="side-meta-row">
          <span className="ico"><IconGlobe /></span> {PROFILE.langs}
        </span>
        <a className="side-meta-row" href={`mailto:${PROFILE.email}`}>
          <span className="ico"><IconMail /></span> {PROFILE.email}
        </a>
        <a className="side-meta-row" href={PROFILE.github} target="_blank" rel="noreferrer">
          <span className="ico"><IconBranch /></span> github.com/nisarg0330
        </a>
      </div>

      <a className="btn" href={resumePDF} download style={{ width: "100%" }}>
        <IconDownload /> Download résumé
      </a>

      <div className="side-divider" />

      <p className="sec-marker" style={{ marginBottom: 12 }}>{"// get in touch"}</p>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <button className="btn btn-accent" onClick={() => scrollTo("contact")}>
          Send a message
        </button>
        <a className="btn" href={PROFILE.linkedin} target="_blank" rel="noreferrer">
          Connect on LinkedIn
        </a>
      </div>
    </>
  );
}
